module.exports = __webpack_public_path__ + "static/media/muscle_front_1.c05a0e86.png";